export default __webpack_public_path__ + "static/media/entrepreneur-1340649_1920.82d5a42c.jpg";